import kidDrawing from './images/girl_learning.jpg';
import kidsCreativeClass from './images/adults_learning.jpg';
import kidsLearning from './images/group_learning.jpg';
import childPortrait from './images/group_learning.jpg';
import ownerAvif from './images/owner3.avif';
import ownerAvifAlternative from './images/owner.avif';
import ownerWebp from './images/owner3.webp';
import ownerWebpAlternative from './images/owner.webp';

import mainLogo from './images/main-logo.png';
import star1 from './images/star_1.svg';
import star2 from './images/star_2.svg';
import owner2 from './images/owner2.png';
import owner2Avif from './images/owner2.avif';
import owner2Webp from './images/owner2.webp';
import together from './images/together.png';
import empathy from './images/empathy.png';
import experience from './images/experience.png';
import idea from './images/idea.png';
import leftArrow from './images/left_arrow.png';
import rightArrow from './images/right_arrow.png';

const Images = {
  kidDrawing,
  kidsCreativeClass,
  kidsLearning,
  childPortrait,
  owner: ownerAvif, // Primary format (AVIF)
  ownerAvif,
  ownerAvifAlternative,
  ownerWebpAlternative,
  ownerWebp, // Fallback format
  mainLogo,
  star1,
  star2,
  owner2,
  owner2Avif,
  owner2Webp,
  together,
  empathy,
  experience,
  idea,
  leftArrow,
  rightArrow
};

export default Images; 